module.exports["menu"] = "_menu_11f88d";
module.exports["menuCheckbox"] = "_menuCheckbox_11f88d";
module.exports["menuToggle"] = "_menuToggle_11f88d";
module.exports["focus-visible"] = "_focus-visible_11f88d";
module.exports["line"] = "_line_11f88d";